import { render, staticRenderFns } from "./AdditionalUsers.vue?vue&type=template&id=3fb2d59a&scoped=true"
import script from "./AdditionalUsers.vue?vue&type=script&lang=js"
export * from "./AdditionalUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb2d59a",
  null
  
)

export default component.exports